import React from 'react';
import { CardContent, CardHeader, Typography } from '@mui/material';
import PrimaryButton from '../../shared/Buttons/PrimaryButton';
import { useTranslation } from 'react-i18next';
import { GeneralComponentsProps } from '../../../models/Admin/AdminProductsManagement';

export const GeneralQueryCard: React.FC<GeneralComponentsProps> = (props) => {
    const { isLoading, formSubmit, translatePrefix } = props;

    const { t } = useTranslation('admin', {
        keyPrefix: 'PRODUCTS_MANAGEMENT.' + translatePrefix,
    });

    return (
        <>
            <CardHeader title={t('TITLE')} />
            <CardContent>
                <Typography paragraph>{t('CONTENT')}</Typography>
                <Typography paragraph>{t('AFTER_RUN')}</Typography>
                <PrimaryButton onClick={formSubmit} disabled={isLoading}>
                    {t('BUTTON')}
                </PrimaryButton>
            </CardContent>
        </>
    );
};
